import { RedirectToLegacyEcommerceOptions } from './types';
/**
 * util function to redirect to legacy ecommerce
 */
export const redirectToLegacyEcommerce = ({
  path,
  discountCode,
  skus,
  bundle,
}: RedirectToLegacyEcommerceOptions) => {
  const params = new URLSearchParams();

  if (discountCode) {
    params.set('code', discountCode);
  }
  if (bundle) {
    params.set('bundle', bundle);
  }
  skus.forEach((sku) => params.append('sku', sku));
  window.location.replace(
    `${
      process.env.NEXT_PUBLIC_EDX_LEGACY_ECOM_BASE_URL! + path
    }?${params.toString()}`,
  );
};
